import { render, staticRenderFns } from "./NewBuyerBank.vue?vue&type=template&id=b546abc2&scoped=true&"
import script from "./NewBuyerBank.vue?vue&type=script&lang=js&"
export * from "./NewBuyerBank.vue?vue&type=script&lang=js&"
import style0 from "./NewBuyerBank.vue?vue&type=style&index=0&id=b546abc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b546abc2",
  null
  
)

export default component.exports